import * as yup from 'yup';
import { RendererType } from '../data-models/field-definition';

const allowedFileTypes = ['image/png'];
const extensionMap = {
  png: 'image/png',
};
const maxFileSize = 10 * 1024 * 1024;

export function clientLogoField(showNewFileField: boolean) {
  return {
    logo: yup
      .mixed()
      .required()
      .test(
        'is-valid-size',
        'Max file size is 10MB',
        (value) => value instanceof File && value.size <= maxFileSize
      )
      .test(
        'is-valid-type',
        `File type must be ${allowedFileTypes.map((t) => t.split('/')[1] || t).join('/')}`,
        (value) => {
          return value instanceof File && allowedFileTypes.includes(value.type);
        }
      )
      .label('Logo')
      .meta({
        description: 'Logo must be a PNG file and less than 10MB',
        renderer: showNewFileField ? RendererType.fileUpload2 : RendererType.fileUpload,
        rendererMeta: {
          acceptTypes: allowedFileTypes,
          acceptExtensions: Object.keys(extensionMap),
        },
      }),
  };
}

export function clientLogoSchema(showNewFileField: boolean) {
  return yup.object(clientLogoField(showNewFileField));
}

const profileLogoUrlPattern = /^(https?:\/\/|data:image\/)/i;
const maxProfileLogoUrlLength = 2 * 1024 * 1024;

export function clientProfileFields() {
  return {
    displayName: yup
      .string()
      .trim()
      .max(120, 'Display name must be 120 characters or less')
      .label('Display Name')
      .meta({
        renderer: RendererType.text,
      }),
    profileLogoUrl: yup
      .string()
      .trim()
      .test(
        'is-valid-profile-logo-url',
        'Must be an http(s):// URL or a data:image/... URL',
        (value) => !value || profileLogoUrlPattern.test(value)
      )
      .max(maxProfileLogoUrlLength, 'Profile logo URL must be 2MB or less')
      .label('Profile Logo URL')
      .meta({
        description: 'Paste an image URL or a data:image/... URL (max 2MB)',
        renderer: RendererType.text,
      }),
  };
}

export function clientProfileSchema() {
  return yup.object(clientProfileFields());
}
